module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-right-4747a20c.svg";